import { c as _c } from "react/compiler-runtime";
import { Button } from '@common/components';
import SvgChevrondown from '@common/icon/SvgChevrondown';
import { cn } from '@core/utils';
export const InfiniteListMoreButton = t0 => {
  const $ = _c(6);
  const {
    onClick,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full max-w-[480px]", "mobile-tablet:max-w-full", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SvgChevrondown className="size-16 text-Gray-black" />;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== onClick || $[4] !== t1) {
    t3 = <Button className={t1} theme="sub-fill" onClick={onClick} dimensions="H40">더보기{t2}</Button>;
    $[3] = onClick;
    $[4] = t1;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
};